<div class="selection-summary-block">
  <div class="selection-header">
    <div class="selection-text">{{ Header }}</div>
    <div class="selection-icon" (click)="OnCloseClick()">
      <div class="icon1"></div>
    </div>
  </div>
  <div class="save-selection-body" *ngIf="isSelectionSummaryClick">
    <div class="save-selection-text">
      Please enter the selection name (max 50 characters)
    </div>
    <div class="save-selection-input">
      <input
        type="text"
        placeholder="Selection name.."
        [(ngModel)]="SaveSelection"
        maxlength="50"
        autocomplete="off"
        name="SaveSelection"
        (keydown)="onKeyDown($event)"
      />
    </div>
    <div class="save-selection-btn" (click)="onSaveBtnClick()">
      <div class="btn-text">Save</div>
    </div>
  </div>
  <div
    class="summary-view"
    [ngStyle]="{ height: isSelectionSummaryClick ? '80%' : '100%' }"
  >
    <div class="summary-view-outer">
      <!-- Compare Across section -->
      <div class="summary-header">Compare Across</div>
      <div class="selection-summary-view-text">
        <div
          *ngFor="let title of titleSection"
          class="selection-header-container"
        >
          <span class="selection-key">{{ title.key }}:</span>
          <span class="selection-value">{{ title.value }}</span>
        </div>
      </div>

      <ng-container *ngFor="let entryPoint of entryPointSections">
        <div class="summary-header">{{ entryPoint.header }}</div>
        <div class="selection-summary-view-text">
          <div class="selection-header-container">
            <ng-container
              *ngIf="
                !entrypointColorService.checkForEntryPoint(entryPoint.header)
              "
            >
              <span class="selection-value">{{ entryPoint.value }}</span>
            </ng-container>
            <ng-container
              *ngIf="
                entrypointColorService.checkForEntryPoint(entryPoint.header)
              "
            >
              <ng-container
                *ngFor="let value of entryPoint.value.split(','); index as i"
              >
                <span
                  [ngStyle]="{
                    'background-color':
                      entrypointColorService.getHighlightColor(
                        entryPoint.header,
                        value
                      ),
                    padding: '0.1rem  0.1rem 0 0.1rem',
                  }"
                  class="selection-value"
                  >{{ value }}</span
                >
                <span
                  *ngIf="i < entryPoint.value.split(',').length - 1"
                  class="selection-value"
                >
                  ,
                </span>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <!-- Selections section -->
      <div class="summary-header">Selections</div>
      <div class="selection-summary-view-text">
        <div
          *ngFor="let selection of selections"
          class="selection-header-container"
        >
          <span class="selection-key">{{ selection.key }}:</span>
          <span class="selection-value">{{ selection.value }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
